import React, { useState } from "react";
import { auth } from "./firebase";
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut, 
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";

export function LoginModal({ isOpen, onClose, user }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);

  const handleAuth = async () => {
    try {
      if (isRegister) await createUserWithEmailAndPassword(auth, email, password);
      else await signInWithEmailAndPassword(auth, email, password);
      onClose();
    } catch (err) { alert(err.message); }
  };

  const handleGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      onClose();
    } catch (err) { alert(err.message); }
  };

  if (!isOpen) return null;

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.85)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000, padding: "20px" }}>
      <div style={{ background: "#1a1f2b", padding: "30px", borderRadius: "20px", width: "100%", maxWidth: "400px", position: "relative", border: "1px solid #2d3446" }}>
        
        <button onClick={onClose} style={{ position: "absolute", top: "20px", right: "20px", background: "none", border: "none", color: "#fff", fontSize: "1.5rem", cursor: "pointer" }}>✕</button>
        
        <h2 style={{ color: "#fff", marginBottom: "30px", fontSize: "1.8rem", textAlign: "left" }}>{user ? "Account" : (isRegister ? "Sign Up" : "Login")}</h2>

        {user ? (
          <div style={{ textAlign: "center" }}>
            <p style={{ color: "#fff", marginBottom: "20px" }}>Logged in as:<br/>{user.email}</p>
            <button onClick={() => signOut(auth)} style={{ width: "100%", padding: "12px", background: "#4a3aff", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "bold", cursor: "pointer" }}>LOGOUT</button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: "15px", textAlign: "left" }}>
              <label style={{ color: "#888", fontSize: "0.8rem", display: "block", marginBottom: "8px" }}>Email</label>
              <input style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #3d4454", background: "#fff", color: "#000" }} value={email} onChange={e => setEmail(e.target.value)} />
            </div>

            <div style={{ marginBottom: "25px", textAlign: "left" }}>
              <label style={{ color: "#888", fontSize: "0.8rem", display: "block", marginBottom: "8px" }}>Password</label>
              <input type="password" style={{ width: "100%", padding: "12px", borderRadius: "10px", border: "1px solid #3d4454", background: "#fff", color: "#000" }} value={password} onChange={e => setPassword(e.target.value)} />
            </div>

            <button onClick={handleAuth} style={{ width: "100%", padding: "15px", background: "#4a3aff", color: "#fff", border: "none", borderRadius: "10px", fontWeight: "bold", fontSize: "1rem", cursor: "pointer", marginBottom: "15px" }}>
              {isRegister ? "Create Account" : "Login"}
            </button>

            <button onClick={handleGoogle} style={{ width: "100%", padding: "12px", background: "#fff", color: "#000", border: "1px solid #ddd", borderRadius: "10px", fontWeight: "bold", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "20px" }}>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" width="18" alt="G" /> Sign in with Google
            </button>

            <div style={{ textAlign: "center", fontSize: "0.8rem" }}>
              <span onClick={() => setIsRegister(!isRegister)} style={{ color: "#00acc1", cursor: "pointer" }}>
                {isRegister ? "Already have an account? Login" : "Don't have an account? Sign up"}
              </span>
              <br/><br/>
              {!isRegister && (
                <span onClick={() => sendPasswordResetEmail(auth, email).then(() => alert("Reset link sent!"))} style={{ color: "#555", cursor: "pointer" }}>
                  Forgot Password?
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}